import React, { useState, useEffect } from 'react';


import { useNavigate } from 'react-router';
import Link from 'react'
import { 
  Search, 
  Plus, 
  Edit2, 
  Trash2, 
  Download, 
  Eye, 
  Calendar,
  User,
  DollarSign,
  FileText,
  CheckCircle,
  XCircle,
  ChevronLeft,
  ChevronRight,
  ArrowUpDown,
  Printer
} from 'lucide-react';

const ViewIncome = () => {
  // Sample data
  const initialIncomeData = [
    {
      id: 1,
      itemName: 'Membership Fees',
      amount: 5000,
      date: '2024-06-01',
      paidBy: 'Hussein Abebe',
      receipt: 'MF-2024-001',
      category: 'Membership',
      status: 'completed',
      notes: 'Annual membership fee (2024)'
    },
    {
      id: 2,
      itemName: 'Share Contribution',
      amount: 15000,
      date: '2024-05-25',
      paidBy: 'Mulugeta Bekele',
      receipt: 'SC-2024-002',
      category: 'Shares',
      status: 'completed',
      notes: 'One-time share purchase'
    },
    {
      id: 3,
      itemName: 'Coffee Sales',
      amount: 8200,
      date: '2024-05-20',
      paidBy: 'Local Market',
      receipt: 'CS-2024-003',
      category: 'Sales',
      status: 'completed',
      notes: 'Bulk coffee beans sale'
    },
    {
      id: 4,
      itemName: 'Grain Sales',
      amount: 12000,
      date: '2024-05-18',
      paidBy: 'Trader K',
      receipt: 'GS-2024-004',
      category: 'Sales',
      status: 'completed',
      notes: 'Maize and wheat bulk sale'
    },
    {
      id: 5,
      itemName: 'Loan Interest Collected',
      amount: 3400,
      date: '2024-05-10',
      paidBy: 'Member Group A',
      receipt: 'LI-2024-005',
      category: 'Finance',
      status: 'completed',
      notes: 'Interest from short-term loan'
    },
    {
      id: 6,
      itemName: 'Service Charge',
      amount: 900,
      date: '2024-05-08',
      paidBy: 'Customer Z',
      receipt: 'SCG-2024-006',
      category: 'Services',
      status: 'pending',
      notes: 'Late payment processing fee'
    },
    {
      id: 7,
      itemName: 'Donation',
      amount: 2000,
      date: '2024-05-05',
      paidBy: 'Community Fund',
      receipt: 'DN-2024-007',
      category: 'Donations',
      status: 'completed',
      notes: 'Support to cooperative program'
    },
    {
      id: 8,
      itemName: 'Market Stall Rent',
      amount: 1800,
      date: '2024-05-02',
      paidBy: 'Trader Y',
      receipt: 'MR-2024-008',
      category: 'Rent',
      status: 'completed',
      notes: 'Monthly stall rent'
    },
  ];

  const navigate=useNavigate()
  // State
  const [incomeData, setIncomeData] = useState(initialIncomeData);
  const [filteredData, setFilteredData] = useState(initialIncomeData);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [selectedStatus, setSelectedStatus] = useState('all');
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(5);
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [selectedIncome, setSelectedIncome] = useState(null);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
  
  // Form state
  const [formData, setFormData] = useState({
    itemName: '',
    amount: '',
    date: new Date().toISOString().split('T')[0],
    paidBy: '',
    receipt: '',
    category: 'Services',
    status: 'pending',
    notes: ''
  });

  // Calculate totals
  const totalIncome = incomeData.reduce((sum, item) => sum + item.amount, 0);
  const completedIncome = incomeData
    .filter(item => item.status === 'completed')
    .reduce((sum, item) => sum + item.amount, 0);
  const pendingIncome = incomeData
    .filter(item => item.status === 'pending')
    .reduce((sum, item) => sum + item.amount, 0);

  // Date-based stats
  const todayKey = new Date().toISOString().split('T')[0];
  const todayIncome = incomeData
    .filter(item => item.date === todayKey)
    .reduce((sum, item) => sum + item.amount, 0);

  const now = new Date();
  const monthIncome = incomeData
    .filter(item => {
      const d = new Date(item.date);
      return d.getFullYear() === now.getFullYear() && d.getMonth() === now.getMonth();
    })
    .reduce((sum, item) => sum + item.amount, 0);

  const yearIncome = incomeData
    .filter(item => new Date(item.date).getFullYear() === now.getFullYear())
    .reduce((sum, item) => sum + item.amount, 0);

  // Categories and statuses
  const categories = ['all', 'Services', 'Consulting', 'Licensing', 'Training', 'Development', 'Design'];
  const statuses = ['all', 'completed', 'pending'];

  // Filter and search
  useEffect(() => {
    let result = incomeData;

    // Search filter
    if (searchTerm) {
      result = result.filter(item =>
        item.itemName.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.paidBy.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.receipt.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.category.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    // Category filter
    if (selectedCategory !== 'all') {
      result = result.filter(item => item.category === selectedCategory);
    }

    // Status filter
    if (selectedStatus !== 'all') {
      result = result.filter(item => item.status === selectedStatus);
    }

    // Sorting
    if (sortConfig.key) {
      result.sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
          return sortConfig.direction === 'asc' ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
          return sortConfig.direction === 'asc' ? 1 : -1;
        }
        return 0;
      });
    }

    setFilteredData(result);
    setCurrentPage(1);
  }, [searchTerm, selectedCategory, selectedStatus, incomeData, sortConfig]);

  // Sort handler
  const handleSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
  };

  // Pagination
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredData.length / itemsPerPage);

  // CRUD Operations
  const handleAddIncome = () => {
    const newIncome = {
      id: incomeData.length + 1,
      ...formData,
      amount: parseFloat(formData.amount)
    };
    setIncomeData([newIncome, ...incomeData]);
    setIsAddModalOpen(false);
    resetForm();
  };

  const handleEditIncome = () => {
    setIncomeData(incomeData.map(item => 
      item.id === selectedIncome.id ? { ...selectedIncome, ...formData, amount: parseFloat(formData.amount) } : item
    ));
    setIsEditModalOpen(false);
    resetForm();
  };

  const handleDeleteIncome = () => {
    setIncomeData(incomeData.filter(item => item.id !== selectedIncome.id));
    setIsDeleteModalOpen(false);
  };

  const handleViewIncome = (income) => {
    setSelectedIncome(income);
    setIsViewModalOpen(true);
  };

  const handleEditClick = (income) => {
    setSelectedIncome(income);
    setFormData({
      itemName: income.itemName,
      amount: income.amount,
      date: income.date,
      paidBy: income.paidBy,
      receipt: income.receipt,
      category: income.category,
      status: income.status,
      notes: income.notes
    });
    setIsEditModalOpen(true);
  };

  const handleDeleteClick = (income) => {
    setSelectedIncome(income);
    setIsDeleteModalOpen(true);
  };

  const resetForm = () => {
    setFormData({
      itemName: '',
      amount: '',
      date: new Date().toISOString().split('T')[0],
      paidBy: '',
      receipt: '',
      category: 'Services',
      status: 'pending',
      notes: ''
    });
    setSelectedIncome(null);
  };


  function HandleAddincome(){
    navigate("/addincome")
  }

  // Export to CSV (Excel)
  const exportToCSV = () => {
    try {
      const headers = ['ID', 'Item Name', 'Amount', 'Date', 'Paid By', 'Receipt', 'Category', 'Status', 'Notes'];
      const csvData = incomeData.map(item => [
        item.id,
        `"${item.itemName}"`, // Wrap in quotes to handle commas in item names
        `${item.amount.toFixed(2)} BIRR`,
        item.date,
        `"${item.paidBy}"`, // Wrap in quotes
        item.receipt,
        item.category,
        item.status,
        `"${item.notes || ''}"` // Wrap in quotes and handle empty notes
      ].join(','));

      const csv = [headers.join(','), ...csvData].join('\n');
      
      // Create BOM for UTF-8 to ensure Excel opens it correctly
      const BOM = '\uFEFF';
      const blob = new Blob([BOM + csv], { type: 'text/csv;charset=utf-8;' });
      const url = window.URL.createObjectURL(blob);
      
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `income_data_${new Date().toISOString().split('T')[0]}.csv`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error exporting to CSV:', error);
      alert('Failed to export data. Please try again.');
    }
  };

  // Alternative: Export to Excel (using xlsx if you have the library)
  // If you want to use Excel format, you can install 'xlsx' library:
  // npm install xlsx
  /*
  import * as XLSX from 'xlsx';
  
  const exportToExcel = () => {
    const ws = XLSX.utils.json_to_sheet(incomeData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Income Data");
    XLSX.writeFile(wb, `income_data_${new Date().toISOString().split('T')[0]}.xlsx`);
  };
  */

  // Print function
  const handlePrint = () => {
    window.print();
  };

  // Format currency
  const formatCurrency = (amount) => {
    try {
      const formatted = new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(amount || 0);
      return `${formatted} BIRR`;
    } catch (e) {
      return (amount || 0) + ' BIRR';
    }
  };

  // Format date
  const formatDate = (dateString) => {
    try {
      return new Date(dateString).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      });
    } catch (e) {
      return dateString;
    }
  };

  // Sort indicator
  const getSortIndicator = (key) => {
    if (sortConfig.key !== key) return <ArrowUpDown className="w-4 h-4 ml-1 text-gray-400" />;
    return sortConfig.direction === 'asc' ? '↑' : '↓';
  };

  return (
    <div className="flex min-h-screen bg-gray-50">
      {/* Sidebar */}
  
      
      {/* Main Content */}
      <div className="flex-1 p-6 ml-0 lg:ml-24">
        {/* Header */}
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-800 mb-2">Income Management</h1>
          <p className="text-gray-600">View and manage all income transactions</p>
        </div>

        {/* Stats Cards */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8">
          <div className="bg-white rounded-2xl shadow-sm p-6 border border-gray-100">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-gray-500 mb-1">Total Income</p>
                <h3 className="text-2xl font-bold text-gray-800">{formatCurrency(totalIncome)}</h3>
              </div>
              <div className="p-3 rounded-xl bg-blue-50">
                <DollarSign className="w-6 h-6 text-blue-600" />
              </div>
            </div>
            <div className="mt-4 text-sm text-green-600">
              <CheckCircle className="w-4 h-4 inline mr-1" />
              {incomeData.filter(i => i.status === 'completed').length} completed transactions
            </div>
          </div>

          <div className="bg-white rounded-2xl shadow-sm p-6 border border-gray-100">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-gray-500 mb-1">Today</p>
                <h3 className="text-2xl font-bold text-gray-800">{formatCurrency(todayIncome)}</h3>
              </div>
              <div className="p-3 rounded-xl bg-green-50">
                <CheckCircle className="w-6 h-6 text-green-600" />
              </div>
            </div>
            <div className="mt-4 text-sm text-gray-600">
              {totalIncome > 0 ? ((todayIncome / totalIncome) * 100).toFixed(1) : 0}% of total income
            </div>
          </div>

          <div className="bg-white rounded-2xl shadow-sm p-6 border border-gray-100">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-gray-500 mb-1">This Month</p>
                <h3 className="text-2xl font-bold text-gray-800">{formatCurrency(monthIncome)}</h3>
              </div>
              <div className="p-3 rounded-xl bg-amber-50">
                <XCircle className="w-6 h-6 text-amber-600" />
              </div>
            </div>
            <div className="mt-4 text-sm text-gray-600">
              {incomeData.filter(i => new Date(i.date).getMonth() === now.getMonth() && new Date(i.date).getFullYear() === now.getFullYear()).length} transactions this month
            </div>
          </div>
          <div className="bg-white rounded-2xl shadow-sm p-6 border border-gray-100">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-gray-500 mb-1">This Year</p>
                <h3 className="text-2xl font-bold text-gray-800">{formatCurrency(yearIncome)}</h3>
              </div>
              <div className="p-3 rounded-xl bg-indigo-50">
                <FileText className="w-6 h-6 text-indigo-600" />
              </div>
            </div>
            <div className="mt-4 text-sm text-gray-600">
              {incomeData.filter(i => new Date(i.date).getFullYear() === now.getFullYear()).length} transactions this year
            </div>
          </div>
        </div>

        {/* Controls Bar */}
        <div className="bg-white rounded-2xl shadow-sm p-6 mb-6 border border-gray-100">
          <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
            {/* Search */}
            <div className="flex-1">
              <div className="relative">
                <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                <input
                  type="text"
                  placeholder="Search by item, client, receipt..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="w-full pl-10 pr-4 py-2.5 bg-gray-50 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>
            </div>

            {/* Filters */}
            <div className="flex flex-wrap gap-3">
              <select
                value={selectedCategory}
                onChange={(e) => setSelectedCategory(e.target.value)}
                className="px-4 py-2.5 bg-gray-50 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              >
                {categories.map(cat => (
                  <option key={cat} value={cat}>
                    {cat === 'all' ? 'All Categories' : cat}
                  </option>
                ))}
              </select>

              <select
                value={selectedStatus}
                onChange={(e) => setSelectedStatus(e.target.value)}
                className="px-4 py-2.5 bg-gray-50 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              >
                {statuses.map(status => (
                  <option key={status} value={status}>
                    {status === 'all' ? 'All Status' : status.charAt(0).toUpperCase() + status.slice(1)}
                  </option>
                ))}
              </select>

              {/* Action Buttons */}
              <button
                onClick={ HandleAddincome}
                className="flex items-center gap-2 px-4 py-2.5 bg-blue-600 text-white rounded-xl hover:bg-blue-700 transition-colors"
              >
                Add Income
              </button>

              <button
                onClick={exportToCSV}
                className="flex items-center gap-2 px-4 py-2.5 bg-gray-100 text-gray-700 rounded-xl hover:bg-gray-200 transition-colors"
              >
                <Download className="w-5 h-5" />
                <span className="hidden md:inline">Export CSV</span>
              </button>

              <button
                onClick={handlePrint}
                className="flex items-center gap-2 px-4 py-2.5 bg-gray-100 text-gray-700 rounded-xl hover:bg-gray-200 transition-colors"
              >
                <Printer className="w-5 h-5" />
                <span className="hidden md:inline">Print</span>
              </button>
            </div>
            {/* Total summary at bottom of filters */}
            <div className="mt-4 flex justify-end">
              <div className="text-sm text-gray-600">Total: <span className="font-bold text-gray-800">{formatCurrency(totalIncome)}</span></div>
            </div>
          </div>
        </div>

        {/* Income Table */}
        <div className="bg-white rounded-2xl shadow-sm overflow-hidden border border-gray-100">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-gray-50">
                <tr>
                  <th 
                    className="py-4 px-6 text-left text-sm font-medium text-gray-600 cursor-pointer hover:bg-gray-100"
                    onClick={() => handleSort('itemName')}
                  >
                    <div className="flex items-center">
                      Item Name
                      {getSortIndicator('itemName')}
                    </div>
                  </th>
                  <th 
                    className="py-4 px-6 text-left text-sm font-medium text-gray-600 cursor-pointer hover:bg-gray-100"
                    onClick={() => handleSort('amount')}
                  >
                    <div className="flex items-center">
                      Amount
                      {getSortIndicator('amount')}
                    </div>
                  </th>
                  <th 
                    className="py-4 px-6 text-left text-sm font-medium text-gray-600 cursor-pointer hover:bg-gray-100"
                    onClick={() => handleSort('date')}
                  >
                    <div className="flex items-center">
                      Date
                      {getSortIndicator('date')}
                    </div>
                  </th>
                  <th 
                    className="py-4 px-6 text-left text-sm font-medium text-gray-600 cursor-pointer hover:bg-gray-100"
                    onClick={() => handleSort('paidBy')}
                  >
                    <div className="flex items-center">
                      Paid By
                      {getSortIndicator('paidBy')}
                    </div>
                  </th>
                  <th 
                    className="py-4 px-6 text-left text-sm font-medium text-gray-600 cursor-pointer hover:bg-gray-100"
                    onClick={() => handleSort('receipt')}
                  >
                    <div className="flex items-center">
                      Receipt
                      {getSortIndicator('receipt')}
                    </div>
                  </th>
                  <th className="py-4 px-6 text-left text-sm font-medium text-gray-600">
                    Category
                  </th>
                  <th className="py-4 px-6 text-left text-sm font-medium text-gray-600">
                    Status
                  </th>
                  <th className="py-4 px-6 text-left text-sm font-medium text-gray-600">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100">
                {currentItems.length > 0 ? (
                  currentItems.map((income) => (
                    <tr key={income.id} className="hover:bg-gray-50 transition-colors">
                      <td className="py-4 px-6">
                        <div>
                          <div className="font-medium text-gray-800">{income.itemName}</div>
                          <div className="text-sm text-gray-500 truncate max-w-xs">{income.notes}</div>
                        </div>
                      </td>
                      <td className="py-4 px-6">
                        <div className="font-bold text-gray-800">{formatCurrency(income.amount)}</div>
                      </td>
                      <td className="py-4 px-6">
                        <div className="flex items-center gap-2">
                          <Calendar className="w-4 h-4 text-gray-400" />
                          <span className="text-gray-600">{formatDate(income.date)}</span>
                        </div>
                      </td>
                      <td className="py-4 px-6">
                        <div className="flex items-center gap-2">
                          <User className="w-4 h-4 text-gray-400" />
                          <span className="text-gray-600">{income.paidBy}</span>
                        </div>
                      </td>
                      <td className="py-4 px-6">
                        <div className="flex items-center gap-2">
                          <FileText className="w-4 h-4 text-gray-400" />
                          <span className="font-mono text-gray-600">{income.receipt}</span>
                        </div>
                      </td>
                      <td className="py-4 px-6">
                        <span className="px-3 py-1 rounded-full text-sm font-medium bg-blue-50 text-blue-700">
                          {income.category}
                        </span>
                      </td>
                      <td className="py-4 px-6">
                        <div className={`inline-flex items-center gap-1 px-3 py-1 rounded-full text-sm font-medium ${
                          income.status === 'completed' 
                            ? 'bg-green-50 text-green-700' 
                            : 'bg-amber-50 text-amber-700'
                        }`}>
                          {income.status === 'completed' ? (
                            <CheckCircle className="w-4 h-4" />
                          ) : (
                            <XCircle className="w-4 h-4" />
                          )}
                          {income.status.charAt(0).toUpperCase() + income.status.slice(1)}
                        </div>
                      </td>
                      <td className="py-4 px-6">
                        <div className="flex items-center gap-2">
                          <button
                            onClick={() => handleViewIncome(income)}
                            className="p-2 rounded-lg hover:bg-gray-100 transition-colors"
                            title="View Details"
                          >
                            <Eye className="w-4 h-4 text-gray-600" />
                          </button>
                          <button
                            onClick={() => handleEditClick(income)}
                            className="p-2 rounded-lg hover:bg-blue-50 transition-colors"
                            title="Edit"
                          >
                            <Edit2 className="w-4 h-4 text-blue-600" />
                          </button>
                          <button
                            onClick={() => handleDeleteClick(income)}
                            className="p-2 rounded-lg hover:bg-red-50 transition-colors"
                            title="Delete"
                          >
                            <Trash2 className="w-4 h-4 text-red-600" />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="8" className="py-12 text-center">
                      <div className="text-gray-400">
                        <FileText className="w-12 h-12 mx-auto mb-3" />
                        <p className="text-lg">No income records found</p>
                        <p className="text-sm">Try adjusting your search or add a new income record</p>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          {filteredData.length > 0 && (
            <div className="flex items-center justify-between px-6 py-4 border-t border-gray-100">
              <div className="text-sm text-gray-500">
                Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, filteredData.length)} of {filteredData.length} entries
              </div>
              <div className="flex items-center gap-2">
                <button
                  onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                  disabled={currentPage === 1}
                  className="p-2 rounded-lg hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  <ChevronLeft className="w-5 h-5" />
                </button>
                
                {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
                  let pageNum;
                  if (totalPages <= 5) {
                    pageNum = i + 1;
                  } else if (currentPage <= 3) {
                    pageNum = i + 1;
                  } else if (currentPage >= totalPages - 2) {
                    pageNum = totalPages - 4 + i;
                  } else {
                    pageNum = currentPage - 2 + i;
                  }
                  
                  return (
                    <button
                      key={pageNum}
                      onClick={() => setCurrentPage(pageNum)}
                      className={`px-3 py-1 rounded-lg ${
                        currentPage === pageNum
                          ? 'bg-blue-600 text-white'
                          : 'hover:bg-gray-100 text-gray-600'
                      }`}
                    >
                      {pageNum}
                    </button>
                  );
                })}
                
                <button
                  onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                  disabled={currentPage === totalPages}
                  className="p-2 rounded-lg hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  <ChevronRight className="w-5 h-5" />
                </button>
              </div>
            </div>
          )}
        </div>

        {/* Modals (Add, Edit, Delete, View) */}
        {/* Keep your existing modal code here */}
        {/* ... */}
        
      </div>
    </div>
  );
};

export default ViewIncome;